export default __webpack_public_path__ + "static/media/carrosel04.27f78acd.png";